<div>

  <mat-tab-group>
    <mat-tab label="Video">
      <mat-form-field class="pe-se-input">
        <mat-label>Youtube ID</mat-label>
        <input matInput
               [(ngModel)]="item.data.link" (change)="onChange()">
      </mat-form-field>
      <mat-form-field class="pe-se-input">
        <mat-label>Height</mat-label>
        <input matInput
               [(ngModel)]="item.data.playerSetting.height" type="number" (change)="onChange()">
      </mat-form-field>
      <mat-button-toggle-group class="btn-toggle" [(ngModel)]="item.data.playerSetting.color" (change)="onChange()">
        <mat-button-toggle value="red">Red</mat-button-toggle>
        <mat-button-toggle value="white">White</mat-button-toggle>
      </mat-button-toggle-group>
      <mat-slide-toggle
        class="pe-se-input"
      [(ngModel)]="item.data.playerSetting.modestbranding" (change)="onChange()">
        Youtube Logo
      </mat-slide-toggle>
      <mat-slide-toggle
        class="pe-se-input"
      [(ngModel)]="item.data.playerSetting.loop" (change)="onChange()">
        Loop
      </mat-slide-toggle>
      <mat-slide-toggle
        class="pe-se-input"
      [(ngModel)]="item.data.playerSetting.controls" (change)="onChange()">
        Control Button
      </mat-slide-toggle>
      <mat-slide-toggle
        class="pe-se-input"
      [(ngModel)]="item.data.playerSetting.autoplay" (change)="onChange()">
        AutoPlay
      </mat-slide-toggle>
    </mat-tab>

    <mat-tab label="Layout">
      <app-sub-layout-setting [item]="item" [layoutSetting]="layoutSetting"></app-sub-layout-setting>
    </mat-tab>
  </mat-tab-group>

</div>

